import { defineAsyncComponent as e } from "vue";
//#region src/index.ts
var t = e(() => import("./entities-list-rWt1jqsA.js")), n = e(() => import("./multiple-entities.selector-PJsf88aX.js")), r = {
	messages: {
		en: {},
		de: {}
	},
	routes: []
};
//#endregion
export { t as EntitiesList, n as MultipleEntitiesSelector, r as entityPickerModule };

//# sourceMappingURL=index.es.js.map